import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import './index.css'
import '../util/bootstrap.min.css'

const TemplateWrapper = ({ children }) => (
  <div id="___reactroot">
    <div id="___contentroot">{children()}</div>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js